import { Selector } from '@ngxs/store';
import { AuthState } from './auth.state';
import {
  AuthResponse,
  AuthSocialResponse,
  ISuccessResponse,
} from './auth-state.model';

export class AuthSelectors {
  @Selector([AuthState])
  static statusOtp(state: ISuccessResponse): boolean {
    return state.status;
  }

  @Selector([AuthState])
  static statusLogin(state: AuthResponse): boolean {
    return state.status;
  }

  @Selector([AuthState])
  static user(state: AuthResponse): AuthResponse['user'] {
    return state.user;
  }

  @Selector([AuthState])
  static dataAuthSocial(state: AuthSocialResponse): AuthSocialResponse['data'] {
    return state.data;
  }
}
